import _ from 'lodash';
import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators, UntypedFormArray } from '@angular/forms';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { CampaignService } from '../../services/campaign.service';
import { select, Store } from '@ngrx/store';
import { loadEventList } from 'app/event/features/event.actions';
import { SharedService } from 'app/virtual-event/services/shared.service';
import { MDBSwitchService } from 'app/core/services/mdb-switch.service';
import { selectPartySignUpCampaignList } from 'app/campaign/features/campaign.selectors';

@Component({
  selector: 'app-campaign-party-signup-settings',
  templateUrl: './campaign-party-signup-settings.component.html',
  styleUrls: ['./campaign-party-signup-settings.component.scss']
})
export class CampaignPartySignUpSettingsComponent implements OnInit, OnDestroy {

  @Input() formGroupCampaignTypeData: UntypedFormGroup = null;

  private _campaignId: any = null;

  @Input()
  set campaignId(id: any) {
    this._campaignId = id;
  };
  get campaignId(): any {
    return this._campaignId;
  }

  public soldCount: number = 0;

  public partySignupCampaigns$: any = this.store.pipe(
    select(selectPartySignUpCampaignList),
  );

  public isTolalInventoryValid = true

  public takeUntilSubject: Subject<any> = new Subject();

  constructor(
    public store: Store,
    public campaignService: CampaignService,
    public mdbSwitchService: MDBSwitchService,
    private sharedService: SharedService,
  ) {
    this.store.dispatch({
      type: loadEventList.type,
      payload: this.sharedService.token
    });
  }

  ngOnInit(): void {
    this.campaignService.configGroup(this.formGroupCampaignTypeData, this.formGroupCampaignTypeData,  'postActivityFormUrlRequired', [
      { name: 'postActivityFormUrl', defaultValue: "", validators: [Validators.required, Validators.pattern(/^(?:(?:http(s)?):\/\/(www\.)?)[-a-z0-9+&@#\/%?=~_|!:,.;]*[-a-z0-9+&@#\/%=~_|]$/i)] }
    ], this.takeUntilSubject);

    const sendTickets = this.formGroupCampaignTypeData.get('sendTickets') as UntypedFormControl;

    sendTickets.valueChanges.pipe(
      filter(value => !value),
      takeUntil(this.takeUntilSubject)
    ).subscribe(() => {
      const presetOptions = this.formGroupCampaignTypeData.get('presetOptions') as UntypedFormArray;
      for(let presetOption of presetOptions.controls) {
        const dontSendTickets = presetOption.get('dontSendTickets');
        dontSendTickets.setValue(false);
      }
    })
  }

  ngOnDestroy(): void {
    this.takeUntilSubject.next(null);
    this.takeUntilSubject.complete();
  }
}
